import {useQuery, gql} from "@apollo/client";
var  HOME_BLOG = gql`
query BlogList {
  blog(first: 3, where: {localization: {culture_starts_with: "fa"}}){
    displayText
    htmlBody {
      html
    }
    bag {
      contentItems {
        ... on BlogImage {
          createdUtc
          displayText
          blogImageField {
            urls(first: 1)
          }
        }
      }
    }
    blogOverview {
      html
    }
    blogAuthor
    blogCreateDate
    alias {
      alias
    }
    contentItemId
  }
}
`;

export const useHomeBlog = () => {
  const {error, loading, data} = useQuery(HOME_BLOG);
  
  return {
    error, data, loading
  };
  } 